/* Alunos vinculados ao responsável logado.

   O backend resolve o vínculo pelo token (Auth::user()->id em
   ResponsavelEscopoService::doUsuarioLogado()) — não precisa mais passar o id
   do responsável nem inferir o vínculo a partir de singleView. */

import { api } from "./api";

/** @returns {Promise<Array<{id:number, name:string, surname:?string}>>} */
export function buscarAlunosVinculados() {
  return api.filhos();
}
